export default __webpack_public_path__ + "static/media/flag-no.a371d1e2.svg";